export default {
  rivalsEmailsAgreement:
    "I want to receive emails with offers and updates from Rivals.",
  thirdPartyEmailsAgreement:
    "I want to receive special offers from Rivals Fan Shop, Rivals Ticketing (SeatGeek) and other Rivals partners."
};
